import { FC } from "react";
import { useTranslation } from "@vixi/localization";
import { ButtonLink, Img } from "@vixi/ui";

export const NoCourses: FC = () => {
  const { t, tFile } = useTranslation();

  return (
    <div className="relative m-auto w-118.25">
      <Img contain src={tFile("/images/", "bubble-no-courses.png")} className="w-full" />
      <ButtonLink
        to={"/create"}
        variant="contained"
        size="medium"
        className="absolute bottom-5 left-5"
      >
        {t("Action.CreateCourse")}
      </ButtonLink>
    </div>
  );
};
